import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id BDB3C0CD-D017-4895-82AD-41FEE4351FA6
 * name sort-bool-ascending
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-bool-ascending.svg
 * tags
 * - Text / Content / Format 
 */
export const SortBoolAscendingIcon = createSvgIcon(<><path d="M19 17H22L18 21L14 17H17V3H19V17M7 3C4.79 3 3 4.79 3 7S4.79 11 7 11 11 9.21 11 7 9.21 3 7 3M7 9C5.9 9 5 8.1 5 7S5.9 5 7 5 9 5.9 9 7 8.1 9 7 9M7 13C4.79 13 3 14.79 3 17S4.79 21 7 21 11 19.21 11 17 9.21 13 7 13Z" /></>, 'SortBoolAscendingIcon');
export default SortBoolAscendingIcon